export var CustomPDFReportDesignation;
(function (CustomPDFReportDesignation) {
    CustomPDFReportDesignation["DRAFT"] = "draft";
    CustomPDFReportDesignation["DELIVERABLE"] = "deliverable";
})(CustomPDFReportDesignation || (CustomPDFReportDesignation = {}));
